import { gql } from "@apollo/client";

// Dashboard summary across all of the logged-in customer's active sites for a date
// range (YYYY-MM-DD). The customer comes from the auth token server-side, so there's
// no customerId variable. `response`: { range, totals, perDay[], sites[], onDuty[] }.
export const getCustomerPortalOverviewQuery = gql`
query($startDate: String!, $endDate: String!){
  getCustomerPortalOverview(startDate: $startDate, endDate: $endDate) {
    message
    response
  }
}
`;
